import React, { useEffect, useState } from "react";
import ExplorerService from '../../services/API/explorerService';
import ArticlesBGImgOne from '../../assets/images/dashboard/articles-1.svg';
import { useNavigate } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';

const ExploreArticles = ({ isDashboard }) => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [explorerPost, setExplorerPost] = useState([]);
    const [explorerPostTypeZero, setExplorerPostTypeZero] = useState([]);

    useEffect(() => {
        // Initialize AOS only once on mount
        AOS.init({
            offset: 200, // Trigger animations 200px from the top
            delay: 100, // Delay animations by 100ms
            duration: 500, // Animation duration in milliseconds
            easing: 'ease-in-out', // Default easing for animations
            once: false, // Whether animations should only happen once
            mirror: false, // Whether animations should happen on scroll up
        });

        // Fetch posts on component mount
        if (isDashboard) {
            getPost(1);
        } else {
            getPost(1);
            getPosts(0);
        }

    }, []);

    const getPosts = async (postType) => {
        try {
            const take = 10;
            const page = 1;
            setIsLoading(true); // Show loading state
            const response = await ExplorerService.getPost(take, page, postType);
            if (response?.statusCode === 200) {
                setExplorerPostTypeZero(response.result);
            }
        } catch (error) {
            console.error("Failed to fetch posts:", error);
        } finally {
            setIsLoading(false); // Hide loading state
        }
    };
    const getPost = async (postType) => {
        try {
            const take = 10;
            const page = 1;
            setIsLoading(true); // Show loading state
            const response = await ExplorerService.getPost(take, page, postType);
            if (response?.statusCode === 200) {
                setExplorerPost(response.result);
            }
        } catch (error) {
            console.error("Failed to fetch posts:", error);
        } finally {
            setIsLoading(false); // Hide loading state
        }
    };

    const isMobile = () => window.innerWidth <= 768; // Utility function to determine if mobile

    const aosArticleEffects = (index) =>
        `fade-${isMobile() ? (index % 2 === 0 ? "top" : "bottom") : (index % 2 === 0 ? "right" : "left")}`;


    const handleShowAll = () => {
        navigate('/explore-articals');
    }

    const redirectToArticleDetail = (id) => {
        navigate('/articles-detail?postId=' + id);
    }

    return (
        <div className="custom-container">
            <section className="explore-articles">
                <div className={isDashboard ? "justify-content-between" : ''}>
                    <h3 className="title">Explore articles</h3>
                    {isDashboard && (
                        <span className="text-primary cursor-pointer view-more" onClick={handleShowAll}>View More</span>
                    )}
                </div>
                <div className={`${explorerPost?.posts?.length > 0 ? 'article-list' : ''}`}>
                    {explorerPost?.posts?.length > 0 ? (
                        explorerPost.posts.map((item, index) => (
                            <div
                                key={item.id || index} // Add a unique key for React
                                className="article-card"
                                data-aos={aosArticleEffects(index)}
                                data-aos-anchor-placement="top-bottom"
                                data-aos-offset="200"
                                onClick={() => redirectToArticleDetail(item?.id)}>
                                <div
                                    className="article-bg-img cursor-pointer shadow-lg"
                                    style={{
                                        backgroundImage: `url(${item.coverImage || ArticlesBGImgOne})`,
                                        backgroundSize: "cover",
                                        backgroundPosition: "center",
                                        backgroundRepeat: "no-repeat",
                                    }}
                                ></div>
                                <p className="sub-title mt-2 mb-0">
                                    {item?.title?.split(":")[0]}
                                </p>
                                <p className="description mb-0">
                                    {item?.title?.split(":")[1]}
                                </p>
                            </div>
                        ))
                    ) : isLoading ? (
                        Array.from({ length: 2 }).map((_, index) => (
                            <div
                                key={index} // Add a unique key for React
                                className="article-card skeleton"
                                data-aos={aosArticleEffects(index)}
                                data-aos-anchor-placement="top-bottom"
                                data-aos-offset="200"
                            >
                                <div className="article-bg-img cursor-pointer skeleton-bg"></div>
                                <p className="skeleton-title"></p>
                                <p className="skeleton-text"></p>
                            </div>
                        ))
                    ) : (
                        <div className="content">No articles scheduled yet</div>
                    )}
                </div>
                {!isDashboard && (
                    <div className={`${explorerPostTypeZero?.posts?.length > 0 ? 'article-list mt-3' : ''}`}>
                        {explorerPostTypeZero?.posts?.length > 0 ? (
                            explorerPostTypeZero.posts.map((item, index) => (
                                <div
                                    key={item.id || index} // Add a unique key for React
                                    className="article-card"
                                    data-aos={aosArticleEffects(index)}
                                    data-aos-anchor-placement="top-bottom"
                                    data-aos-offset="200"
                                    onClick={() => redirectToArticleDetail(item?.id)}>
                                    <div
                                        className="article-bg-img cursor-pointer shadow-lg"
                                        style={{
                                            backgroundImage: `url(${item.coverImage || ArticlesBGImgOne})`,
                                            backgroundSize: "cover",
                                            backgroundPosition: "center",
                                            backgroundRepeat: "no-repeat",
                                        }}
                                    ></div>
                                    <p className="sub-title mt-2 mb-0">
                                        {item?.title?.split(":")[0]}
                                    </p>
                                    <p className="description mb-0">
                                        {item?.title?.split(":")[1]}
                                    </p>
                                </div>
                            ))
                        ) : isLoading ? (
                            Array.from({ length: 2 }).map((_, index) => (
                                <div
                                    key={index} // Add a unique key for React
                                    className="article-card skeleton"
                                    data-aos={aosArticleEffects(index)}
                                    data-aos-anchor-placement="top-bottom"
                                    data-aos-offset="200"
                                >
                                    <div className="article-bg-img cursor-pointer skeleton-bg"></div>
                                    <p className="skeleton-title"></p>
                                    <p className="skeleton-text"></p>
                                </div>
                            ))
                        ) : (
                            <div className="content">No articles scheduled yet</div>
                        )}
                    </div>
                )}

            </section>
        </div>
    );
};

export default ExploreArticles;
